/**
 * Checks if currentDomain is inside initialDomain
 * @param currentDomain - The minimum and maximum date of the current domain.
 * @param initialDomain - The initial domain.
 * @returns initial zoomOut boolean value
 */
export function getInitialZoomOut<T extends Date[] | number[]>(
  currentDomain: T | undefined,
  initialDomain: T,
) {
  if (currentDomain === undefined) {
    return false;
  }
  return (
    +currentDomain[0] > +initialDomain[0] ||
    +currentDomain[1] < +initialDomain[1]
  );
}
